export default {"src":"/_next/static/media/calendar-dots.c723d0ca.svg","height":18,"width":25,"blurWidth":0,"blurHeight":0};